import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { FIELD_DESCRIPTION, FIELD_TITLE } from 'constants/fields';
import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import './Styles.scss';

var PreviewForm = /*#__PURE__*/function (_Component) {
  _inherits(PreviewForm, _Component);

  var _super = _createSuper(PreviewForm);

  function PreviewForm() {
    var _this;

    _classCallCheck(this, PreviewForm);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "renderTitle", function (field) {
      return /*#__PURE__*/React.createElement("div", {
        className: "input-label"
      }, field.value);
    });

    _defineProperty(_assertThisInitialized(_this), "renderDescription", function (field) {
      return /*#__PURE__*/React.createElement("div", null, field.value);
    });

    _defineProperty(_assertThisInitialized(_this), "renderInput", function (field) {
      var type = field.type.toLowerCase();
      return /*#__PURE__*/React.createElement("div", {
        className: "placeholder-input ".concat(type)
      }, _this.props.translate(type));
    });

    _defineProperty(_assertThisInitialized(_this), "renderField", function (field, index) {
      if (field.type == FIELD_TITLE) {
        return /*#__PURE__*/React.createElement("div", {
          key: 'field-' + index,
          className: "form-row field"
        }, _this.renderTitle(field, index));
      }

      if (field.type == FIELD_DESCRIPTION) {
        return /*#__PURE__*/React.createElement("div", {
          key: 'field-' + index,
          className: "form-row field"
        }, _this.renderDescription(field, index));
      }

      return /*#__PURE__*/React.createElement("div", {
        key: 'field-' + index,
        className: "form-row"
      }, _this.renderInput(field, index));
    });

    return _this;
  }

  _createClass(PreviewForm, [{
    key: "render",
    value: function render() {
      if (this.props.fields == null) {
        return null;
      }

      var fields = _toConsumableArray(this.props.fields);

      fields.sort(function (a, b) {
        return a.sortOrder > b.sortOrder ? 1 : -1;
      });
      return /*#__PURE__*/React.createElement("div", {
        className: "dynamic-form"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form form-component"
      }, fields.map(this.renderField)));
    }
  }]);

  return PreviewForm;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations)
  };
}

export default connect(mapStateToProps, null, null, {
  pure: false
})(PreviewForm);